import { AxiosResponse } from "axios";
import API from "core/networks/API";
import { IApiResponseSuccess } from "core/networks/Interfaces";
import { call, put, takeLatest } from "redux-saga/effects";
import { API_GET_BADGE_NOTIFICATION, API_GET_NOTIFICATION, API_READ_NOTIFICATION, API_UPDATE_AVATAR } from "../api";
import {
  FETCH_DATA_NOTIFICATION_REQUEST,
  fetchListNotificationError,
  fetchListNotificationSuccess,
  UPDATE_SETTING_NOTIFICATION_REQUEST,
  updateSettingNotificationError,
  updateSettingNotificationSuccess,
  READ_NOTIFICATION_REQUEST,
  readNotificationError,
  readNotificationSuccess,
  GET_BADGE_NOTIFICATION_REQUEST,
  getBadgeNotificationSuccess,
  getBadgeNotificationError,
} from "./actions";
import { route } from "core/router";
import { updateInfoUser } from "modules/Auth/store/actions";
import type { NotificationListResponse } from "./types";

function* fetchDataNotification(action: any) {
  try {
    const response: AxiosResponse<NotificationListResponse> = yield call(
      API.get,
      API_GET_NOTIFICATION,
      action.payload
    );
    console.log("response fetchDataHistory", response?.data);
    yield put(fetchListNotificationSuccess(response?.data?.data));
  } catch (error: any) {
    console.log("error fetchDataHistory", error);
    yield put(fetchListNotificationError(error as Error));
  }
}

function* updateSetting(action: any) {
  try {
      const data = action.payload || {};
      console.log("updateSetting", data);
      const url  =  route(API_UPDATE_AVATAR)
      const response: AxiosResponse = yield call(API.post, url, data);
      console.log("response updateSetting", response);
      const dataRes = response?.data?.data
      dataRes.setting = data
      yield put(updateInfoUser(response.data.data));
      yield put(updateSettingNotificationSuccess(response.data.data));
  } catch (error) {
      yield put(updateSettingNotificationError(error as Error));
    }
  }

//readNotification
function* readNotification(action: any) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.put,
      API_READ_NOTIFICATION,
      action.payload
    );
    console.log("response fetchDataHistory", response?.data);
    yield put(readNotificationSuccess(response?.data?.data));
  } catch (error: any) {
    console.log("error fetchDataHistory", error);
    yield put(readNotificationError(error as Error));
  }
}

function* getBadgeNotification(action: any) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<any>> = yield call(
      API.get,
      API_GET_BADGE_NOTIFICATION,
      action.payload
    );
    console.log("response getBadgeNotification", response?.data);
    yield put(getBadgeNotificationSuccess(response?.data?.data));
  } catch (error: any) {
    console.log("error getBadgeNotification", error);
    yield put(getBadgeNotificationError(error as Error));
  }
}

export default function* MenuSaga() {
  yield takeLatest(FETCH_DATA_NOTIFICATION_REQUEST, fetchDataNotification);
  yield takeLatest(UPDATE_SETTING_NOTIFICATION_REQUEST, updateSetting);
  yield takeLatest(READ_NOTIFICATION_REQUEST, readNotification);
  yield takeLatest(GET_BADGE_NOTIFICATION_REQUEST, getBadgeNotification);

}
